import addOrReplace from 'forms-utils-lib/utils/array/addOrReplace';
const addOrUpdateCommunicationCheckbox = ({
  legalConsent,
  checkbox,
  oldCheckbox
}) => {
  const communicationConsentCheckboxes = legalConsent.communicationConsentCheckboxes;
  const updatedLegalConsentOptions = addOrReplace(communicationConsentCheckboxes, ({
    communicationTypeId
  }) => oldCheckbox !== undefined && communicationTypeId === oldCheckbox.communicationTypeId, checkbox);
  return Object.assign({}, legalConsent, {
    communicationConsentCheckboxes: updatedLegalConsentOptions
  });
};
export default addOrUpdateCommunicationCheckbox;